export const FRIENDLY_FIELD_NAMES: Record<string, string> = {
  productType: 'Product Type',
  quantity: 'Quantity',
  askingPrice: 'Asking Price',
  line1: 'Street Address',
  city: 'City',
  state: 'State/Province',
  postalCode: 'ZIP/Postal Code',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  phone: 'Phone',
  photos: 'Photos',
  condition: 'Condition',
  dimensionLength: 'Length',
  dimensionWidth: 'Width',
}

export function getFriendlyFieldName(field: string): string {
  return FRIENDLY_FIELD_NAMES[field] || field
}

export function formatMissingFields(fields: string[]): string {
  return fields.map(getFriendlyFieldName).join(', ')
}

const BLOCKED_FIELD_MESSAGES = new Map<string, string>([
  ['quantity', 'Enter a quantity.'],
  ['condition', 'Choose a condition.'],
  ['dimensionLength', 'Enter a length.'],
  ['dimensionWidth', 'Enter a width.'],
  ['dimensionHeight', 'Enter a height.'],
  ['firstName', 'Enter your first name.'],
  ['email', 'Enter a valid email address.'],
  ['phone', 'Enter a valid phone number.'],
])

export const DIMENSION_BLOCK_FIELDS = ['dimensionLength', 'dimensionWidth', 'dimensionHeight']

export function blockedFieldMessage(field: string | undefined): string | undefined {
  return field ? BLOCKED_FIELD_MESSAGES.get(field) : undefined
}

export function isShownBesideField(field: string | undefined): boolean {
  return field !== undefined && BLOCKED_FIELD_MESSAGES.has(field)
}
